<template>
  <v-select
    v-model="modulosSelecionados"
    :items="modulos"
    label="Módulos"
    item-text="text"
    item-value="value"
    multiple
    chips
  />
</template>

<script>
export default {
  name: 'FiltroModulos',
  data() {
    return {
      modulos: [
        {
          text: 'Delivery',
          value: 'delivery'
        },
        {
          text: 'Agendamento',
          value: 'agendamento'
        },
        {
          text: 'Comanda Fácil',
          value: 'comanda_facil'
        }
      ],
      modulosSelecionados: []
    }
  },
  watch: {
    modulosSelecionados() {
      this.filtrarModulos()
    }
  },
  methods: {
    filtrarModulos() {
      let filtro = {
        delivery: false,
        agendamento: false,
        comanda_facil: false
      }
      for (let i = 0; i < this.modulosSelecionados.length; i ++) {
        const e = this.modulosSelecionados[i]
        filtro[e] = true
      }
      this.$emit('filtrar-modulos', filtro)
    }
  }
}
</script>
